export class Orientation {
    static HORZ = new Orientation("horz");
    static VERT = new Orientation("vert");

    static flip(from: Orientation) {
        if (from === Orientation.HORZ) {
            return Orientation.VERT;
        } else {
            return Orientation.HORZ;
        }
    }

    /** @hidden @internal */
    private _name: 'horz' | 'vert'

    /** @hidden @internal */
    private constructor(name: 'horz' | 'vert') {
        this._name = name;
    }

    get name() {
        return this._name;
    }

    toString() {
        return this._name;
    }
}



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/Orientation.ts